<div class="w-full flex flex-col items-center py-4">
    <div class="flex flex-col gap-[30px] w-full max-w-[632px] px-4">
        <!-- Back to overview button -->
        <button mat-button class="text-app-global-primary mr-auto" routerLink="/settings/organizations" i18n>
            <mat-icon svgIcon="arrow-left"></mat-icon>
            Terug naar overzicht
        </button>

        <!-- Page title -->
        <div class="flex items-center gap-4">
            <!-- Title -->
            <h1 *ngIf="organizationId" class="text-[22px] font-semibold shrink-0" i18n>Organisatie bewerken</h1>
            <h1 *ngIf="!organizationId" class="text-[22px] font-semibold shrink-0" i18n>Organisatie aanmaken</h1>

            <!-- Current organization name -->
            <p *ngIf="organization && breakpoint.sm.value"
                class="text-[22px] px-[8px] py-[10px] bg-app-global-quaternary text-app-global-quaternary-contrast rounded-[5px] whitespace-nowrap text-ellipsis overflow-hidden">
                {{organization.name}}
            </p>
        </div>

        <div class="flex flex-col gap-[15px]">
            <!-- General -->
            <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Algemeen</p>
            <!-- Organization name -->
            <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                <p class="text-base shrink-0 min-w-[120px]" i18n>Naam organisatie</p>
                <mat-form-field class="grow w-full sm:max-w-[420px]">
                    <input matInput i18n-placeholder placeholder="Organisatie naam"
                        [formControl]="organisationFormGroup.controls.name">
                    <mat-error i18n>Veld is verplicht</mat-error>
                </mat-form-field>
            </div>
            <!-- App name -->
            <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                <div class="flex sm:flex-col gap-1 shrink-0 min-w-[120px]">
                    <p class="text-base" i18n>Applicatie naam</p>
                    <p class="text-base text-app-global-text-secondary" i18n>(Optioneel)</p>
                </div>
                <mat-form-field class="grow w-full sm:max-w-[420px]">
                    <input matInput i18n-placeholder placeholder="Applicatie naam"
                        [formControl]="organisationFormGroup.controls.appName">
                </mat-form-field>
            </div>
        </div>

        <div class="flex flex-col gap-[15px]">
            <!-- Models -->
            <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Modellen</p>
            <!-- LLM -->
            <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                <p class="text-base shrink-0 min-w-[120px]" i18n>LLM</p>
                <mat-form-field class="grow w-full sm:max-w-[420px]">
                    <mat-select placeholder="Selecteer een large language model" i18n-placeholder
                        [formControl]="organisationFormGroup.controls.llm" [compareWith]="compareModelsById"
                        class="no-label">
                        <mat-option *ngFor="let model of availableAiModels | filterModelsByType:'llm'" [value]="model">
                            {{ model.model }} ({{ model.provider }})</mat-option>
                    </mat-select>
                    <mat-error i18n>Veld is verplicht</mat-error>
                </mat-form-field>
            </div>
            <!-- Embedding model -->
            <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                <p class="text-base shrink-0 min-w-[120px]" i18n>Embedding model</p>
                <!-- Only allow editing of embedding model when creating new organization -->
                <mat-form-field *ngIf="!organization" class="grow w-full sm:max-w-[420px]">
                    <mat-select placeholder="Selecteer een embedding model" i18n-placeholder
                        [formControl]="organisationFormGroup.controls.embeddingModel" [compareWith]="compareModelsById"
                        class="no-label">
                        <mat-option *ngFor="let model of availableAiModels | filterModelsByType:'embedding'"
                            [value]="model">{{ model.model }} ({{ model.provider }})</mat-option>
                    </mat-select>
                    <mat-error i18n>Veld is verplicht</mat-error>
                </mat-form-field>
                <p *ngIf="organization" class="text-base sm:ml-[42px] grow w-full sm:max-w-[420px]">
                    {{ organization.EmbeddingModel.model }} ({{ organization.EmbeddingModel.provider }})
                </p>
            </div>

            <!-- Reranker model -->
            <div class="w-full flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-5">
                <div class="flex sm:flex-col gap-1 shrink-0 min-w-[120px]">
                    <p class="text-base" i18n>Reranker model</p>
                    <p class="text-base text-app-global-text-secondary" i18n>(Optioneel)</p>
                </div>
                <mat-form-field class="grow w-full sm:max-w-[420px]">
                    <mat-select placeholder="Selecteer een reranker model (optioneel)" i18n-placeholder
                        [formControl]="organisationFormGroup.controls.rerankerModel" [compareWith]="compareModelsById"
                        class="no-label">
                        <mat-option *ngFor="let model of availableAiModels | filterModelsByType:'reranker'"
                            [value]="model">{{ model.model }} ({{ model.provider }})</mat-option>
                    </mat-select>
                    <!-- Clear button -->
                    <mat-icon matSuffix class="clear-form-field"
                        *ngIf="organisationFormGroup.controls.rerankerModel.value"
                        (click)="$event.stopPropagation(); organisationFormGroup.controls.rerankerModel.reset()"
                        svgIcon="x"></mat-icon>
                </mat-form-field>
            </div>

        </div>

        <!-- Features -->
        <div class="w-full flex flex-col items-start justify-between gap-2">
            <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Functionaliteiten</p>
            <div class="flex flex-col" [formGroup]="organisationFormGroup">
                <mat-checkbox formControlName="featureChunkRetrievalButton" i18n>Doorzoek documenten knop</mat-checkbox>
                <mat-checkbox formControlName="featureCollectionAdvancedSettings" i18n>Geavanceerde
                    instellingen voor collecties</mat-checkbox>
                <mat-checkbox formControlName="featureBaseModelChat" i18n>
                    Chatten met base model zonder RAG
                </mat-checkbox>
            </div>
        </div>

        <!-- Language -->
        <div class="w-full flex flex-col items-start justify-between gap-2">
            <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Taal</p>
            <mat-radio-group class="flex flex-col" [formControl]="organisationFormGroup.controls.language">
                <mat-radio-button value="nl" i18n>Nederlands</mat-radio-button>
                <mat-radio-button value="en" i18n>Engels</mat-radio-button>
            </mat-radio-group>
        </div>

        <!-- Logo -->
        <div class="flex flex-col gap-2">
            <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Logo</p>
            <!-- Selector -->
            <file-selector [allowedFileExtensions]="['.svg', '.jpg', '.jpeg', '.png']" #fileSelector
                [invalid]="organisationFormGroup.controls.logoFile.hasError('required') && !organisationFormGroup.controls.logoFile.untouched"
                [dragDropEnabled]="breakpoint.lg.value" [showSubtext]="false"
                (filesSelected)="filesSelected($event, 'logo')">
            </file-selector>

            <!-- No files selected error -->
            <mat-error class="text-base"
                *ngIf="organisationFormGroup.controls.logoFile.hasError('required') && !organisationFormGroup.controls.logoFile.untouched"
                i18n>
                Selecteer een bestand
            </mat-error>

            <!-- Logo preview -->
            <div *ngIf="logoPreviewURL" class="flex items-center gap-5">
                <p class="text-base text-app-global-text-secondary" i18n>Voorbeeld: </p>
                <div
                    class="flex items-center p-4 max-w-[280px] h-20 w-full border border-gray-100 bg-app-sidenav-top-background">
                    <img [src]="logoPreviewURL" alt="logo voorbeeld" class="max-w-[200px] max-h-[50px]">
                </div>
            </div>
        </div>

        <!-- Favicon -->
        <div class="flex flex-col gap-2">
            <p class="text-base font-semibold shrink-0 min-w-[120px]" i18n>Favicon</p>
            <p class="text-base text-app-global-text-secondary" i18n>Upload een favicon. Bij geen favicon wordt het logo
                als
                favicon gebruikt.</p>
            <!-- Selector -->
            <file-selector [allowedFileExtensions]="['.svg', '.jpg', '.jpeg', '.png']" #fileSelector
                [invalid]="organisationFormGroup.controls.faviconFile.hasError('required') && !organisationFormGroup.controls.faviconFile.untouched"
                [dragDropEnabled]="breakpoint.lg.value" [showSubtext]="false"
                (filesSelected)="filesSelected($event, 'favicon')">
            </file-selector>

            <!-- Favicon preview -->
            <div *ngIf="faviconPreviewURL || logoPreviewURL" class="flex items-center gap-4">
                <p class="text-base text-app-global-text-secondary">Voorbeeld:</p>

                <div class="p-3 border bg-white w-auto h-auto flex items-center justify-center">
                    <img [src]="faviconPreviewURL || logoPreviewURL" alt="favicon voorbeeld" class="w-8 h-8">
                </div>
            </div>
        </div>

        <!-- Delete / Cancel / Save -->
        <div class="flex justify-between gap-5 items-center">
            <button mat-button class="text-app-global-warning" i18n (click)="deleteOrganization(deleteDialog)"
                [ngClass]="{'invisible': !organizationId}">
                Organisatie verwijderen
            </button>
            <div class="flex items-center gap-5">
                <button mat-button class="text-app-global-text-secondary" routerLink="/settings/organizations" i18n>
                    Annuleren
                </button>
                <button mat-flat-button color="primary"
                    (click)="organization ? updateOrganization() : saveOrganization()" i18n>
                    Opslaan
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Dialog to show when user wants to delete the organization -->
<dynamic-dialog #deleteDialog>
    <h1 title i18n>Organisatie verwijderen</h1>
    <p i18n class="text-center">
        Weet je zeker dat je deze organisatie wilt verwijderen?
    </p>
</dynamic-dialog>